export default "__VITE_ASSET__DiaSAU92__"